import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-3 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]

import { inject, ref } from "vue";
import { getOptions } from "@/core/helpers/convertToOptions";

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  props: {
    tabs: {}
  },
  emits: ["changeTab"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;



const tabs = getOptions(props.tabs, "status");
const currTab = ref(tabs[0].value);
const changeTab = (_tab: any) => {
  currTab.value = _tab;
  emit("changeTab", _tab);
};
const isLoading = inject<boolean>("isLoading");

__expose({
  changeTab,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "nav-item",
        key: index
      }, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-1',
          { active: currTab.value === tab.value },
          { 'disabled opacity-50 pe-none': _unref(isLoading) },
        ]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: ($event: any) => (!_unref(isLoading) && changeTab(tab.value))
        }, _toDisplayString(tab.label), 11, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})